<template>
  <div class="login-container">
    <div v-if="!isDirectLogin" class="login-content">
      <div class="logo-wrapper">
        <img src="@/assets/lundbeck/logo.png" alt="Lundbeck" class="logo" />
      </div>

      <div class="login-card">
        <h3 class="title">{{ $t('login_txt') || '欢迎登录' }}</h3>

        <form class="login-form">
          <div class="input-group">
            <div class="input-label">管理员账号</div>
            <cube-input
              v-model="loginObj.admin"
              :type="type"
              placeholder="请输入管理员用户名"
              :maxlength="20"
              :clearable="clearable"
              :autocomplete="true"
              class="custom-input"
            />
          </div>

          <div class="input-group">
            <div class="input-label">管理员密码</div>
            <cube-input
              v-model="loginObj.password"
              type="password"
              placeholder="请输入管理员密码"
              :maxlength="20"
              :clearable="clearable"
              :autocomplete="true"
              class="custom-input"
            />
          </div>

          <div class="input-group">
            <div class="input-label">员工ID</div>
            <cube-input
              v-model="loginObj.userId"
              :type="type"
              :placeholder="$t('input_uid')"
              :maxlength="20"
              :clearable="clearable"
              :autocomplete="true"
              :eye="eyeObj"
              class="custom-input"
              @blur="blurPwd"
            />
            <p
              class="cube-validator-msg-def"
              :class="{hidden: !loginObj.userIdTips}"
            >
              {{ loginObj.userIdTips }}
            </p>
          </div>
        </form>

        <div class="prompt">当前版本为内部测试版本<br />请使用您的员工ID登录</div>

        <div
          class="login-btn"
          :class="{disable: isloging}"
          @click="adminLogin()"
        >
          {{ $t('login_btn') }}
        </div>
      </div>

      <div class="quick-login-panel">
        <div class="quick-login-title">快速登录 (仅供测试)</div>
        <div class="tags">
          <span class="tag" @click="() => (loginObj.userId = '504735')"><strong>MR</strong> Lu Yang: 504735</span>
          <span class="tag" @click="() => (loginObj.userId = '506295')">MR Wang Ting: 506295</span>
          <span class="tag" @click="() => (loginObj.userId = '930352')">DM Liu Ling: 930352</span>
          <span class="tag" @click="() => (loginObj.userId = '512928')">Li Guoxiong: 512928</span>
          <span class="tag" @click="() => (loginObj.userId = '513769')"><strong>MSL</strong> Zhu Liying: 513769</span>
          <span class="tag" @click="() => (loginObj.userId = '500930')">MA Cao Shuai: 500930</span>
          <span class="tag" @click="() => (loginObj.userId = '507488')"><strong>GA</strong> Qin Nianlong: 507488</span>
          <span class="tag" @click="() => (loginObj.userId = '508834')">KAM Zhang Haibin: 508834</span>
          <span class="tag" @click="() => (loginObj.userId = '506246')"><strong>GBA</strong> Ouyang Yantao: 506246</span>
          <span class="tag" @click="() => (loginObj.userId = '511288')"><strong>GAD</strong> Zhang Li: 511288</span>
          <span class="tag" @click="() => (loginObj.userId = '517777')">GM Zhang Yifan: 517777</span>
          <span class="tag" @click="() => (loginObj.userId = '516607')">Xu Peng: 516607</span>
        </div>
        <div class="quick-login-meta">{{ releaseInfoText }}</div>
      </div>

      <van-popup
        v-model="showRoleSelectPopup"
        class="role-select-popup-container"
        :close-on-click-overlay="false"
        round
      >
        <div class="role-select-box">
          <div class="role-header">请选择登录身份</div>
          <div class="role-list">
            <div
              v-for="(role, index) in rolePopupList"
              :key="index"
              class="role-option"
              @click="onSelectRole(role)"
            >
              <span class="role-name">{{ role.role_name }}</span>
              <van-icon name="arrow" color="#999" />
            </div>
          </div>
        </div>
      </van-popup>
    </div>
  </div>
</template>
<script>
import loginMixins from '@/mixins/loginMixins';
import { Popup, Icon } from 'vant';
import { removeLocalStorage } from '@/utils/index';

export default {
  components: {
    [Popup.name]: Popup,
    [Icon.name]: Icon
  },
  mixins: [loginMixins],
  computed: {
    releaseInfoText() {
      const version = process.env.VUE_APP_DISPLAY_VERSION || '';
      const buildTime = process.env.VUE_APP_BUILD_TIME || '';
      const commitTime = process.env.VUE_APP_GIT_COMMIT_TIME || '';

      if (version && commitTime) {
        return `v${version} | ${commitTime}`;
      }

      if (version) {
        return `v${version}`;
      }

      return buildTime ? ` | ${buildTime}` : '';
    }
  },
  created() {
    removeLocalStorage('open_id');
    removeLocalStorage('token');
    removeLocalStorage('union_id');
  }
};
</script>
<style lang="scss" scoped>
@import '@/styles/var.scss';

.login-container {
  height: 100%;
  min-height: 100vh;
  width: 100%;
  background: linear-gradient(135deg, #f5f7fa 0%, #eef1f6 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  box-sizing: border-box;
}

.login-content {
  width: 100%;
  padding: 20px 0 32px;
  box-sizing: border-box;
}

.logo-wrapper {
  text-align: center;
  margin-bottom: 24px;

  .logo {
    height: 48px;
    width: auto;
    object-fit: contain;
  }
}

.login-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  padding: 32px 24px;
  margin: 0 20px 24px;

  .title {
    font-size: 22px;
    color: #333;
    margin: 0 0 24px 0;
    text-align: center;
    font-weight: 600;
  }

  .login-form {
    .input-group {
      margin-bottom: 16px;

      .input-label {
        font-size: 13px;
        color: #666;
        margin-bottom: 6px;
        font-weight: 500;
        margin-left: 4px;
      }

      .custom-input {
        &::after {
          display: none; // Remove 1px bottom border from cube-ui if present
        }
        background: #f7f8fa;
        border-radius: 8px;
        padding: 2px 4px;
        border: 1px solid #ebedf0;

        &:focus-within {
          background: #fff;
          border-color: #aa341b;
        }
      }

      .cube-validator-msg-def {
        min-height: 12px;
        font-size: 12px;
        color: #e64340;
        text-align: left;
        margin-top: 5px;
        padding-left: 4px;
        &.hidden {
          visibility: hidden;
        }
      }
    }
  }

  .prompt {
    font-size: 12px;
    line-height: 1.6;
    color: #999;
    text-align: center;
    margin: 8px 0 24px 0;
  }

  .login-btn {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    background: linear-gradient(90deg, #aa341b 0%, #d1402b 100%);
    color: #ffffff;
    box-sizing: border-box;
    font-weight: 500;
    padding: 14px 20px;
    font-size: 16px;
    border-radius: 25px; // Fully rounded
    box-shadow: 0 4px 12px rgba(170, 52, 27, 0.2);
    transition: all 0.2s;
    user-select: none;

    &:active {
      transform: scale(0.98);
      box-shadow: 0 2px 6px rgba(170, 52, 27, 0.2);
    }

    &.disable {
      background: #dddddd;
      box-shadow: none;
      cursor: not-allowed;
    }
  }
}

.quick-login-panel {
  text-align: center;

  .quick-login-title {
    font-size: 12px;
    color: #999;
    margin-bottom: 12px;
    position: relative;
    display: inline-block;
    padding: 0 12px;

    &::before, &::after {
      content: '';
      position: absolute;
      top: 50%;
      width: 20px;
      height: 1px;
      background: #ebedf0;
    }
    &::before { right: 100%; }
    &::after { left: 100%; }
  }

  .tags {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 8px;
    margin: 0 10px;

    .tag {
      background: white;
      color: #666;
      font-size: 12px;
      padding: 6px 12px;
      border-radius: 12px;
      border: 1px solid #ebedf0;
      cursor: pointer;
      transition: all 0.2s;

      strong {
        font-weight: 700;
      }

      &:active {
        background: #f0f0f0;
      }
    }
  }

  .quick-login-meta {
    margin-top: 12px;
    font-size: 12px;
    line-height: 1.5;
    color: #8f8f8f;
  }
}

.role-select-popup-container {
  width: 80%;
  max-width: 320px;
  border-radius: 16px;
  overflow: hidden;
}
.role-select-box {
  background: white;
  padding: 0;
}
.role-header {
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  padding: 24px 0 16px;
  color: #333;
}
.role-list {
  padding: 0 20px 24px;
}
.role-option {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f8f9fa;
  padding: 16px 20px;
  margin-bottom: 12px;
  border-radius: 12px;
  font-size: 16px;
  color: #333;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  border: 1px solid transparent;
}
.role-option:active {
  background: #eef1f6;
  border-color: #dcdfe6;
  transform: scale(0.98);
}
.role-name {
  flex: 1;
}
</style>
